export default function getDeleteCookieString({ domain, name }: { domain?: string; name: string }): string {
  let cookieToDelete = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;

  if (domain) {
    cookieToDelete = `${cookieToDelete}; domain=${domain}`;
  }

  return cookieToDelete;
}
